import { render, staticRenderFns } from "./edit-auditFlow.vue?vue&type=template&id=10230220&scoped=true&"
import script from "./edit-auditFlow.vue?vue&type=script&lang=ts&"
export * from "./edit-auditFlow.vue?vue&type=script&lang=ts&"
import style0 from "./edit-auditFlow.vue?vue&type=style&index=0&id=10230220&scoped=true&lang=scss&"
import style1 from "./edit-auditFlow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10230220",
  null
  
)

export default component.exports